import React from 'react';
import ModuleImagePage from '../shared/ModuleImagePage.jsx';

const Sales = () => <ModuleImagePage moduleKey="sales" />;

export default Sales;
